import { aboutData } from '@/mocks/home-data';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">{aboutData.title}</h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {aboutData.description}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {aboutData.stats.map((stat, i) => (
            <div
              key={i}
              className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}